module.exports = __webpack_public_path__ + "static/media/delete.eb7faf83.svg";